<template>
    <div class="person-right">
        <div class="maintop">
            <span>我的预约</span>
        </div>
        <el-divider></el-divider>
        <div>
            <el-button v-if="applyStatus=='10'" type="primary"  @click='addSeeCommunity(applyID)'>我要约看新小区</el-button>
            <div class="person-applys" v-for="(item, index) in appointlist" :key="index">
                <el-divider></el-divider>
                <div class="person-apply">
                    <div class="person-applyl">
                        <img :src="item.coverUrl?item.coverUrl:require('../../assets/imgs/banner.jpg')">
                        <div class="person-applyl-info">
                            <p class="person-applyl-title">{{item.orderCommunityName}} {{item.isNewCommunity == 1 ? "样板间" : item.roomAddress}}</p>
                            
                            <div style="color:blue; ">
                                <p style="margin:10px 0 0 0">
                                    <span v-if="item.status == '已看房'">
                                        <span v-if="item.operateTime != null">
                                            已在{{item.operateTime}}确认看房
                                        </span>
                                        <span>物业联系电话：{{item.propertyPhone}}</span>
                                    </span>
                                    <span v-else-if="item.status == '跟进中' || item.status == '预定'">
                                        <span>确认看房截止到：{{item.bookEndDate + " 23:59"}}</span><br />
                                        <span>物业联系电话：{{item.propertyPhone}}</span>
                                    </span>
                                    <span v-else></span>
                                </p>
                            </div>
                        </div>
                    </div>
                    <div class="person-applyr" style="text-align:right;height: 40px">
                        <div v-if="item.orderDate!=null" style="display:flex;align-items:center;margin-bottom:40px;font-size:14px">
                            <span class="person-applyl-blue" style="margin-left:9px">约看时间：</span>
                            <span class="person-applyl-blue">{{item.orderDate}}</span>
                        </div>
                        <div v-else style="display:flex;align-items:center;margin-bottom:40px;font-size:14px">
                        </div>
                        <el-button type="danger" v-if="item.status==null && item.orderDate==null"   @click="selectOrderTime(item.id,item.bookDateList,item.bookTimeList,item.propertyPhone)">预约看房时间</el-button>
                        <el-button type="primary" v-if=" item.orderDate!=null && (item.status=='预定' || item.status=='跟进中')" @click='confirmSeeRoom(item.id,item.isNewCommunity,item.orderCommunityName,item.applyType)'>确认看房</el-button>
                        <el-button type="danger" v-if=" item.orderDate!=null && (item.status=='预定' || item.status=='跟进中') && item.contractID != null" @click='abandonSelectRoom(item.contractID)'>取消选房</el-button>
                    </div>
                </div>
            </div>
        </div>

        <el-dialog id="select-time"
            title="选择看房时间"
            :visible.sync="selectTimeShow"
            width="30%"
            :center="false"
            top="20vh"
            :close-on-click-modal="false"
            :lock-scroll="false"
            >
            <el-form :model="selectTimeForm"  :rules="selectTimeRules" ref="selectTimeForm">
                <el-row>
                    <el-col :span="24" align="left">
                        <el-form-item label="约看日期：" prop="dateInfo">
                            <el-select no-data-text="请选择约看日期" @change="oldChangeData"  v-model="selectTimeForm.dateInfo" style="width:70%">
                                <el-option
                                    v-for="item in dateList"
                                    :key="item"
                                    :label="item"
                                    :value="item">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24" align="left">
                        <el-form-item label="约看时间：" prop="workBeginTime">
                            <el-select no-data-text="请选择约看时间" v-model="selectTimeForm.workBeginTime" style="width:70%">
                                <el-option
                                    v-for="item in workTimeList"
                                    :key="item"
                                    :label="item"
                                    :value="item">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row> 
                    <el-col>
                        <el-button type="danger" style="width: 100%" @click="submitTime()">确定</el-button>
                    </el-col>
                </el-row>
            </el-form>
        </el-dialog>

        <el-dialog id="add-select-time"
            title="新小区预约看房登记"
            :visible.sync="addSeeRoomShow"
            width="30%"
            :center="false"
            top="20vh"
            :close-on-click-modal="false"
            :lock-scroll="false"
            >
            <el-form :model="addTimeForm" :rules="addTimeRules"  ref="addTimeForm">
                <el-row>
                    <el-col :span="24" align="left">
                        <el-form-item label="约看小区：" prop="newcommunity">
                            <el-select no-data-text="请选择约看小区" @change="newChangeCommunity"  v-model="addTimeForm.newcommunity" style="width:70%">
                                <el-option
                                    v-for="item in newcommunitylist"
                                    :key="item.communityID"
                                    :label="item.communityName"
                                    :value="item.communityID">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24" align="left">
                        <el-form-item label="约看日期：" prop="newDate">
                            <el-select no-data-text="请选择约看日期"  @change="newChangeData"  v-model="addTimeForm.newDate"  style="width:70%">
                                <el-option
                                    v-for="item in newdateList"
                                    :key="item"
                                    :label="item"
                                    :value="item">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24" align="left">
                        <el-form-item label="约看时间：" prop="newWorkBeginDate">
                            <el-select no-data-text="请选择约看时间" v-model="addTimeForm.newWorkBeginDate"  style="width:70%">
                                <el-option
                                    v-for="item in newworkTimeList"
                                    :key="item"
                                    :label="item"
                                    :value="item">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row> 
                    <el-col>
                        <el-button type="danger" style="width: 100%" @click="submitTimeNew()">确定</el-button>
                    </el-col>
                </el-row>
            </el-form>
        </el-dialog>
        <el-dialog id="account-pwd"
          title=""
          :visible.sync="warnningShow"
          width="20%"
          :center="false"
          top="20vh"
          :close-on-click-modal="false"
          :lock-scroll="false"
        >
          <el-form>
            <el-row>
              <div>
                <img :src="require('../../assets/imgs/code_ico1.jpg')" style="width:100%;height:100%;"/>
              </div>
            </el-row>
            <el-row>
              <span style="font-weight: bold;font-size: 16px; color: red;margin-left: 20px;">请扫码关注公众号并完成相应的业务操作!</span>
            </el-row>
            <el-row >
              <el-col>
                <el-button type="primary" style="width: 100%;margin-top:15px;" @click="closeWarn()">关 闭</el-button>
              </el-col>
            </el-row>
          </el-form>
      </el-dialog>
    </div>
</template>

<script>
import UserApi from "@/api/user/index";
export default {
    data(){
        return{
            warnningShow:false,
            selectTimeShow:false,
            addSeeRoomShow:false,
            appointlist:[],
            bookid:null,
            dateList:[],
            workTimeList:[], 
            propertyPhone:"",
            applyStatus:"",
            applyID:null,
            newcommunitylist:[],
            newdateList:[],
            newworkTimeList:[], 
            newCommunityId:null,
            selectTimeForm:{
                dateInfo:"",  
                workBeginTime:"",  
                // workEndTime:"", 
            },  
            selectTimeRules:{
                dateInfo:[
                    {
                        required: true,
                        message: "约看日期不能为空",
                        trigger: "change"
                    }
                ],
                workBeginTime:[
                    {
                        required: true,
                        message: "约看时间不能为空",
                        trigger: "change"
                    }
                ],
            },
            addTimeForm:{
                newDate:"",  
                newWorkBeginDate:"", 
                newcommunity:null,
            },  
            addTimeRules:{
                newDate:[
                    {
                        required: true,
                        message: "约看日期不能为空",
                        trigger: "change"
                    }
                ],
                newWorkBeginDate:[
                    {
                        required: true,
                        message: "约看时间不能为空",
                        trigger: "change"
                    }
                ],
                newcommunity:[
                    {
                        required: true,
                        message: "小区不能为空",
                        trigger: "change"
                    }
                ],
            },
            selectNumForm:{
                receptionDate:null,
                receptionTime:null,
                timeSetupID:null,
                chooseSignID:null,
                num:null
            },
            selectNumRules:{
                receptionDate:[
                    {
                        required: true,
                        message: "预约日期不能为空",
                        trigger: "change"
                    }
                ],
                receptionTime:[
                    {
                        required: true,
                        message: "预约时间不能为空",
                        trigger: "change"
                    }
                ],
            },
            receptionDateList:[],
            receptionDate:null,
            chooseOrderID:null,
            receptionTimeList:[],
        }
    },
    methods:{
        // selectOrderTime(bookid,bookDateList,bookTimeList,propertyPhone){
        //     this.selectTimeShow=true;
        //     this.dateList = bookDateList;
        //     this.bookid = bookid;
        //     this.workTimeList = bookTimeList;
        //     this.propertyPhone = propertyPhone;
        // },
        selectOrderTime(){
            this.warnningShow =true;
        },
        submitTime(){
            var vm = this;
            this.$refs["selectTimeForm"].validate((valid) => {
            if(valid){
                this.$confirm('确定选择此时间约看小区，确定后不可更改？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning',
                    closeOnPressEscape:false,
                    closeOnClickModal:false
                }).then(() => {
                    UserApi.submitSelectTime(vm.bookid, vm.selectTimeForm.dateInfo, vm.selectTimeForm.workBeginTime)
                        .then(()=>{
                            this.$alert('请耐心等待小区物业管家与您取得联系。' + (this.propertyPhone != "" ? "也可主动联系物业：" + this.propertyPhone : ""), '预约成功', {
                                confirmButtonText: '确定',
                                type: 'success'
                            });
                            this.selectTimeShow = false;
                            this.getOrderList();
                        },err=>{
                            this.$message({
                                message: err,
                                type: "error",
                                center: true,
                            });
                        })
                    })
            }
        });
        },
        // confirmSeeRoom(id,isNewCommunity,communtiyName,applyType){
        //     if(isNewCommunity == 1){
        //         this.$confirm('确认已现场看房', '提示', {
        //             confirmButtonText: '确定',
        //             cancelButtonText: '取消',
        //             type: 'warning',
        //             closeOnPressEscape:false,
        //             closeOnClickModal:false
        //         }).then(() => {
        //             UserApi.confirmSeeRoom(id)
        //                 .then((res)=>{
        //                     if (res.success) {
        //                         this.$confirm('恭喜您，你已拥有' + communtiyName + '小区的选房资格！', '提示', {
        //                             confirmButtonText: '确定',
        //                             type: 'success'
        //                         });
        //                         this.getOrderList();
        //                     }
        //                     else{
        //                         this.$message({
        //                             message: res.reason,
        //                             type: "error",
        //                             center: true,
        //                         });
        //                     }
        //                 },err=>{
        //                     this.$message({
        //                         message: err,
        //                         type: "error",
        //                         center: true,
        //                     });
        //                 })
        //             })
        //     }
        //     else{
        //         // 老小区看房确认
        //         this.$confirm('此房源符合我的要求，我想选择此房源。','确认已现场看房？',
        //         {
        //             showClose:false,
        //             type: 'warning',
        //             closeOnPressEscape:false,
        //             closeOnClickModal:false
        //         }).then(() => {
        //             UserApi.confirmSeeRoom(id).then(res => {
        //                 if (res.success) {
        //                     if(res.data=="") {
        //                         this.getOrderList();
        //                         this.$confirm((applyType == 1 ? "立即去在线生成合同？" : "立即去预约现场签约时间？"),"确认看房成功"
        //                         ,{
        //                             showClose:false,
        //                             confirmButtonText: '现在就去',
        //                             type: 'success',
        //                             closeOnPressEscape:false,
        //                             closeOnClickModal:false
        //                         })
        //                         .then(()=>{
        //                             this.$router.push("/User/MyContract");
        //                         })
        //                     }
        //                 }
        //                 else{
        //                     this.$message({
        //                         message: res.reason,
        //                         center: true,
        //                         type: "error"
        //                     });
        //                 }
        //             },err =>{
        //                 this.$message({
        //                     message: err,
        //                     center: true,
        //                     type: "error"
        //                 });
        //             })
        //         })
        //     }            
        // },
        confirmSeeRoom(){
            this.warnningShow = true;
        },
        abandonSelectRoom(){
            this.warnningShow =true;
        },
        // // 取消选房
        // abandonSelectRoom(contractID){
        //     this.$confirm('确认后您所选的房源将被释放，并且将进入轮候重新排队。','确认取消选房？',
        //     {
        //         showClose:false,
        //         type: 'warning',
        //         closeOnPressEscape:false,
        //         closeOnClickModal:false
        //     }).then(() => {
        //         UserApi.abandonSelectRoom(contractID).then(res => {
        //             if (res.success) {
        //                 if(res.data=="") {
        //                     this.$alert("取消选房成功！","提示"
        //                     ,{
        //                         showClose:false,
        //                         confirmButtonText: '确定',
        //                         type: 'success'
        //                     })
        //                     .then(()=>{
        //                         this.getOrderList();
        //                     })
        //                 }
        //             }
        //         })
        //     }).catch(()=>{
        //         this.getOrderList();
        //     })
        // },
        addSeeCommunity(){
            // this.addSeeRoomShow=true;
            // this.getNewCommunityList();
            this.warnningShow = true;
        },
        closeWarn(){
            this.warnningShow = false
        },

        getNewCommunityList(){
            UserApi.getNewCommunityList()
                .then(
                    (res) => {
                        this.newcommunitylist = res.data.dataSource;
                    },
                    (err) => {
                        this.$message({
                            message: err,
                            center: true,
                        });
                    }
                )
                .catch((error) => {
                this.$message({
                    message: error,
                    center: true,
                });
            });
        },
        newChangeCommunity(item){
            this.addTimeForm.newDate=null;
            this.addTimeForm.newWorkBeginDate=null;
            this.newCommunityId=item;
            UserApi.getNewTimeList(item)
            .then(
                res=>{
                    this.newdateList=res.data.bookDateList;
                    // this.newworkTimeList = res.data.bookTimeList;
                }
            )            
        },
        newChangeData(item){
            UserApi.getNewTimeTwoList(this.newCommunityId,item).then(res=>{
                this.addTimeForm.newWorkBeginDate=null;
                this.newworkTimeList = res.data.bookTimeList;
            })
        },
        oldChangeData(item){
           UserApi.getOldTimeTwoList(this.bookid,item).then(res=>{
                this.selectTimeForm.workBeginTime=null;
                this.workTimeList = res.data.bookTimeList;
            })
        },

        submitTimeNew(){
            var vm = this;
            this.$refs["addTimeForm"].validate((valid) => {
            if(valid){
                this.$confirm('确定选择此时间约看小区，确定后不可更改？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
                closeOnPressEscape:false,
                closeOnClickModal:false
                }).then(() => {
                    // console.log(vm.addTimeForm.dateInfo);
                    UserApi.submitSelectTimeNew(vm.addTimeForm.newDate, vm.addTimeForm.newWorkBeginDate,vm.newCommunityId,vm.applyID)
                        .then(()=>{
                            this.$confirm('预约成功，请耐心等待小区物业管家与您取得联系！', '提示', {
                                confirmButtonText: '确定',
                                type: 'success',
                                closeOnPressEscape:false,
                                closeOnClickModal:false
                            });
                            this.addSeeRoomShow = false;
                            this.getOrderList();
                        },err=>{
                            this.$message({
                                message: err,
                                type: "error",
                                center: true,
                            });
                        })
                    })
            }
        });
        },
        getOrderList(){
            UserApi.orderSeeHouseList()
            .then(
                res=>{
                    this.appointlist = res.data;
                }
            )
        },
        getUserIndo(){
            UserApi.getRentInfo().then((data) => {
                this.applyStatus = data.data.status;
                this.applyID=data.data.applyID;
                if(this.applyStatus == '10') {
                    this.newcommunitylist=[];
                    this.newdateList=[];
                    this.newworkTimeList=[];
                }
            })
        },
    },
    activated(){
        this.getOrderList();
        this.getUserIndo();
    }
}
</script>

<style scoped>
.maintop-menu{
    list-style:none;
    padding: 0px;
    margin: 0px 4px 0 18px;
    height: 26px;
    line-height: 26px;
}
.maintop-menu .normal{
    float: left;
    margin-left: 35px;
    cursor: pointer;
    color:#999999;
}
.active1{
    float: left;
    margin-left: 35px;
    cursor: pointer;
    color:#333333;
    border-bottom: 2px solid #2C79CB;
}
.el-divider{
    margin: 0;
}
.person-apply{
    display: flex;
    margin: 41px 0;
    justify-content: space-between;
}
.person-applyl{
    display: flex;
}
.person-applyl img{
    width:200px;
    height: 150px;
}
.person-applyl-info{
    margin-left: 31px;
}
.person-applyl-info p{
    font-family: Source Han Sans CN;
}
.person-applyl-title{
    font-size: 18px;
    font-weight: bold;
    color: #333333;
    line-height: 18px;
}
.person-applyl-price{
    font-size: 18px;
    font-weight: 400;
    color: #FF0000;
    line-height: 18px;
    margin: 21px 0 20px;
}
.person-applyl-info span{
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    line-height: 14px;
}
.person-applyl-tip{
    color: #999999;
}
.person-applyl-blue{
    color: #2C79CB;
}
.grey{
    color: #999999;
}
.red{
    color: red;
}
.blue{
    color: #167CE9;
}
.signunits{
    display: flex;
    height:20px;
    text-align: center;
    align-items: center;
    margin-top: 7.66px;
    margin-bottom: 10px;
}
.signunits .signunit{
    background: #F5F5F5;
    width: 43px;
    height: 20px;
    margin-right: 10px;
    display: flex;
    align-items: center;
}
</style>